import {DateRangePreset} from "./analytics.constants";

const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const getPresetRange = (preset: Exclude<DateRangePreset, "custom">): { startDate: string; endDate: string } => {
    const now = new Date();
    const endDate = now.toISOString().slice(0, 10);
    const start = new Date(now);
    if (preset === "30d") {
        start.setDate(start.getDate() - 30);
    } else if (preset === "3m") {
        start.setMonth(start.getMonth() - 3);
    } else {
        start.setMonth(start.getMonth() - 12);
    }
    return {startDate: start.toISOString().slice(0, 10), endDate};
};

export const todayStr = (): string => new Date().toISOString().slice(0, 10);

export const formatMonthLabel = (month: string): string => {
    const [year, value] = month.split("-");
    const monthNumber = parseInt(value, 10) - 1;
    if (Number.isNaN(monthNumber)) return month;
    const monthName = MONTHS_SHORT[monthNumber];
    return `${monthName} ${year}`;
};

export const formatDateLabel = (dateStr: string): string => {
    const d = new Date(`${dateStr}T12:00:00`);
    if (isNaN(d.getTime())) return dateStr;
    const day = d.getDate();
    const monthName = MONTHS_SHORT[d.getMonth()];
    return `${monthName} ${day}`;
};

export const formatFriendlyDate = (dateStr: string): string => {
    const d = new Date(`${dateStr}T12:00:00`);
    if (isNaN(d.getTime())) return dateStr;
    const months = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

export const truncateLabel = (label: string, max: number = 28): string => {
    return label.length > max ? label.slice(0, max) + "..." : label;
};

export const formatUserType = (userType: string): string => {
    const normalized = userType.trim().toLowerCase();
    if (normalized === "third_party") return "Third Party";
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};
